import { forwardRef } from 'react';

export const AgentPlaceholder = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        ref={ref}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="20" fill="#F7F8FA" />
        <path
          d="M19.9743 29.9005C24.5309 29.9005 28.2247 26.2066 28.2247 21.6501C28.2247 17.0935 24.5309 13.3997 19.9743 13.3997C15.4177 13.3997 11.7239 17.0935 11.7239 21.6501C11.7239 26.2066 15.4177 29.9005 19.9743 29.9005Z"
          stroke="#004B54"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M20.8743 26.2703C20.8743 25.7732 20.4713 25.3702 19.9742 25.3702C19.4771 25.3702 19.0741 25.7732 19.0741 26.2703C19.0741 26.7674 19.4771 27.1704 19.9742 27.1704C20.4713 27.1704 20.8743 26.7674 20.8743 26.2703Z"
          fill="#004B54"
          stroke="#004B54"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.90198 18.35C10.322 13.5788 14.7418 10.0996 19.9742 10.0996C25.2067 10.0996 29.6265 13.5788 31.0465 18.35"
          stroke="#004B54"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M10.1529 18.606C10.1529 18.606 8.75141 18.0297 7.59868 18.606C6.51827 19.1462 6.01645 20.3765 5.94866 21.65C5.87179 23.0941 6.37362 24.5938 7.59868 25.2063C8.75141 25.7827 10.1529 25.2063 10.1529 25.2063C10.1529 25.2063 9.32786 23.3001 9.32786 21.65C9.32786 19.9999 10.1529 18.606 10.1529 18.606Z"
          stroke="#004B54"
          strokeWidth="1.5"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M29.7882 18.606C29.7882 18.606 31.1896 18.0297 32.3424 18.606C33.4228 19.1462 33.9246 20.3765 33.9924 21.65C34.0693 23.0941 33.5674 24.5938 32.3424 25.2063C31.1896 25.7827 29.7882 25.2063 29.7882 25.2063C29.7882 25.2063 30.6132 23.3001 30.6132 21.65C30.6132 19.9999 29.7882 18.606 29.7882 18.606Z"
          stroke="#004B54"
          strokeWidth="1.5"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M19.9744 26.2705C19.9744 26.2705 23.5464 27.0825 25.7497 26.6005C27.4447 26.2297 29.8749 24.9504 29.8749 24.9504"
          stroke="#004B54"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
